import { AxiosResponse } from "axios";

export class BulkDownloadMapper {
  public convertExistingData(result: AxiosResponse): string {
    const { data } = result;
    return data;
  }
}
